import type state from './state';

export const mutations = {
  RESET: 'RESET',
  MUTATE_PAGE_INFO: 'MUTATE_PAGE_INFO',
  MUTATE_SHOP_INFO: 'MUTATE_SHOP_INFO',
  MUTATE_STATE_SAVED: 'MUTATE_STATE_SAVED',
  MUTATE_STATE_MAKE_DEFAULT: 'MUTATE_STATE_MAKE_DEFAULT',
  UPDATE_PAGE_INFO: 'UPDATE_PAGE_INFO',
  CREATE_PAGE_EVENT: 'CREATE_PAGE_EVENT',
  // UPDATE_PAGE_EVENT: "UPDATE_PAGE_EVENT",
  CANCEL_PAGE_EVENT: 'CANCEL_PAGE_EVENT',
  UPDATE_PAGE_EVENTS: 'UPDATE_PAGE_EVENTS',
  UPDATE_PAGE_STATUS_APPLIED_GS: 'UPDATE_PAGE_STATUS_APPLIED_GS',
  UPDATE_PAGE_STATUS_PUBLISHED_GS: 'UPDATE_PAGE_STATUS_PUBLISHED_GS',
  UPDATE_PAGE_PRESET_ID: 'UPDATE_PAGE_PRESET_ID',
  SHOP_META: 'shopMeta',
  SET_FONT_META: 'SET_FONT_META',
  SET_SHOP_METER: 'SET_SHOP_METER',
  SET_USE_TO_DRAGGABLE: 'SET_USE_TO_DRAGGABLE',
  ADD_NAVBAR_TOAST: 'ADD_NAVBAR_TOAST',
  REMOVE_NAVBAR_TOAST: 'REMOVE_NAVBAR_TOAST',
  UPDATE_USER_SCOPE: 'UPDATE_USER_SCOPE',
  SET_CURRENT_SCREEN: 'SET_CURRENT_SCREEN',
  UPDATE_PAGE_IS_PUBLISHED: 'UPDATE_PAGE_IS_PUBLISHED',
  UPDATE_LATEST_PRODUCT_IN_SHOPIFY: 'UPDATE_LATEST_PRODUCT_IN_SHOPIFY',
  UPDATE_LAST_GEM_METER_USED_AT: 'UPDATE_LAST_GEM_METER_USED_AT',
  DECREASE_NUMBER_OF_PUBLISHED_PRODUCT_PAGE: 'DECREASE_NUMBER_OF_PUBLISHED_PRODUCT_PAGE',
  DECREASE_NUMBER_OF_PUBLISHED_ARTICLE_PAGE: 'DECREASE_NUMBER_OF_PUBLISHED_ARTICLE_PAGE',
  DECREASE_NUMBER_OF_PUBLISHED_PAGE: 'DECREASE_NUMBER_OF_PUBLISHED_PAGE',
  COMMIT_PAGE_INFO: 'COMMIT_PAGE_INFO',
  SET_SHOP_INFO_V7: 'SET_SHOP_INFO_V7',
};

export const actions = {
  GET_SHOP_INFO: 'getShopInfo',
  GET_PAGE_INFO: 'getPageInfo',
  SAVE_PAGE: 'savePage',
  CREATE_PAGE_EVENT: 'createPageEvent',
  CANCEL_PAGE_EVENT: 'cancelPageEvent',
  UPDATE_SHOP_META: 'updateShopMeta',
  GET_SHOP_META: 'getShopMeta',
  UPDATE_SHOP_META_USE_KEY: 'updateShopMetaUseKey',
  UPDATE_LAST_USED: 'UPDATE_LAST_USED',
};

export type { TypeShop as TypeShop1 } from '../../app/types/editor/shop';
export type TypeShop = TypeShop1;
export type { TypePage as TypePage1 } from '../../app/types/editor/page';
export type TypePage = TypePage1;

export type UpdatePageParam = {
  saveType: string;
  scheduleMakeDefault: boolean;
  schedulePublishAt: Date | string | number | null;
};

export type BaseEventParam = {
  type: string;
  id: string | number;
  event: string;
  fields: any;
};

export type CreateEventParam = BaseEventParam & {
  body: any;
};

export type CancelEventParam = BaseEventParam;
export type ShopMeta = {
  firstCrawlPresetLiveTheme: boolean;
  onboardingGlobalStyle: OnboardingGlobalStyle;
};

export type FontMeta = {
  activeFonts: null;
  themeFonts: null;
  installedFonts: null;
};

export type Meter = {
  onboarding: boolean;
};

export type OnboardingGlobalStyle = {
  createNewPreset: boolean;
  featurePromotion: boolean;
  previewPreset: boolean;
  previewMode: boolean;
  firstViewListPack: boolean;
  firstSavePreset: boolean;
  applyPreset: boolean;
  savePreset: boolean;
  publicPreset: boolean;
  firstPublicPreset: boolean;
  firstApplyPreset: boolean;
  previewPresetOB: number;
  introducingGlobalStyle: boolean;
  customizeStyle: boolean;
  tooltipColorStyle: boolean;
  tooltipTextStyle: boolean;
  tooltipBorderStyle: boolean;
  tooltipCornerStyle: boolean;
  tooltipSpacingStyle: boolean;
  tooltipButtonStyle: boolean;
  tabSetting: boolean;
};

export type AppState = typeof state;
